import { Button } from '@mantine/core';
import { MyIcon } from '@web/common-ui';
import { useTranslation } from 'react-i18next';

export const OpenMapBtn = ({ link }: { link: string }) => {
  const { t } = useTranslation('landingpage');

  return (
    <Button
      variant="transparent"
      w="fit-content"
      m="0px"
      p="0px"
      leftSection={<MyIcon name="open" />}
      onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
    >
      {t('Locations.ShowMap')}
    </Button>
  );
};
